import { render } from "./Index.vue?vue&type=template&id=26d6fa2a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=26d6fa2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-26d6fa2a"

export default script